define(['app', './ajax-link'], function (app, ajaxLink) {
  return ajaxLink.extend({
    options: {
      callBack: function () {
        var $decouplebutton = this.$el
        var $couplebutton = $decouplebutton.next('.btn--connect-profile')

        $decouplebutton.prev().remove()
        $decouplebutton.remove()
        $couplebutton.removeClass('is-hidden')
      }
    },

    events: {
      click: 'ajaxLink'
    }
  })
})
